import { isLeapYear } from "../date-fns";

export function getSecondsInYear() {
  const currentYear = new Date().getFullYear();
  const daysInYear = isLeapYear(new Date(currentYear, 0, 1)) ? 366 : 365;
  return daysInYear * 24 * 60 * 60;
}
